// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '5e744b145d1621e8152ff686b0d51c448c503cf2';
export const BUILD_NUMBER = '223';
export const BUILD_TIMESTAMP = '2026-08-27T06:46:41.298Z';
